export default {
  none: 0,
  sm: `0.125rem`,
  default: `0.5rem`,
  lg: `1rem`,
  xl: `2rem`,
  xxl: `4rem`,
  full: 9999,
  right: `0 1rem 1rem 0`,
  left: `1rem 0 0 1rem`,
  top: `1rem 1rem 0 0`,
  bottom: `0 0 1rem 1rem`
}
